module.exports = __webpack_public_path__ + "media/images/plans/dinner/point-4-a015ab5e545cf45b99567694680ccdac.jpg";